export default "__VITE_ASSET__2FHhOlGoh4YYcioeclxLGg__"